import { Injector } from '@angular/core';
import { LOCATION_INITIALIZED } from '@angular/common';
import { ConfigService } from './config.service';
// import branch from 'branch-sdk';
import { HttpHeaders } from '@angular/common/http';
import { Constants } from './constants';
import { environment } from 'environments/environment';

// Initializer runs before rest of app is initialized, sets app/event config
export function ConfigInitializer(
  injector: Injector,
  configService: ConfigService
) {
  console.log(`%c${Constants.CONSTANT_WEB_VERSION}`, 'padding: 0.75em 1em; color: white; text-shadow: 0 0 0.25em black, 0 0 1em #4B1FCF;');

  return () =>
    new Promise(
      (resolve: (value: boolean) => void) => {
        const locationInitialized = injector.get(
          LOCATION_INITIALIZED,
          Promise.resolve(null)
        );

        if (window.location.hostname !== environment.publicDomain) {
          configService.$public.set(false);
        } else {
          configService.$public.set(true);
        }

        locationInitialized
          .then(
            () => {
              configService.setEngageApplicationConfigName();

              const getConfigPromise: Promise<boolean> =
                configService.applicationConfigName
                  ? getConfigByApplicationName(configService)
                  : getConfigByConfigName(configService);

              getConfigPromise
                .then(
                  (value: boolean) => {
                    console.log('Config initialized:', value);
                    resolve(value)
                  }
                );
            }
          );
      }
    );
}

export function getConfigByConfigName(
  configService: ConfigService,
  configName?: string
): Promise<boolean> {
  return new Promise(
    (resolve: (value: boolean) => void) => {
      if (!configName) {
        configService.setConfigName();
        configName = configService.configName;
      }

      if (!configName) {
        console.warn('no config name');
        resolve(false);
        return;
      }

      const url: string = `${configService.CONFIG_URL}${configName}`;

      getConfig(
        configService,
        url
      )
        .then(
          (value: boolean) => resolve(value)
        );
    }
  );
}

function getConfigByApplicationName(configService: ConfigService): Promise<boolean> {
  return new Promise(
    (resolve: (value: boolean) => void) => {
      if (!configService?.applicationConfigName) {
        console.warn('no application config name');
        resolve(false);
        return;
      }

      getConfig(
        configService,
        configService.applicationApiUrl
      )
        .then(
          (value: boolean) => resolve(value)
        );
    }
  );
}

function getConfig(
  configService: ConfigService,
  url: string,
): Promise<boolean> {
  return new Promise(
    (resolve: (value: boolean) => void) => {
      const userLang: string = configService.getUserLang() ?? 'en-gb';
      const headers: HttpHeaders = new HttpHeaders({
        Authorization: environment.apiToken,
        'login-source': 'web',
        'Accept-Language': userLang,
        'X-Grip-Version': Constants.CONSTANT_WEB_VERSION
      });

      configService.headers = headers;
      configService.options = { headers };

      configService.http
        .get(
          url,
          configService.options
        )
        .subscribe(
          data => {
            configService.setDataFromApi(data);
            /**
             * Implementing the Branch SDK
             * Redirect to the accept meeting
             */
            // branch.init(configService.branchKey, { 'tracking_disabled': true }, (err, data) => {
            //   if (data != undefined && data.data_parsed != undefined) {
            //     /**
            //      * If meetingid, then it means a meeting should be accepted
            //      */
            //     if (data.data_parsed.meeting_id != undefined) {
            //       const meetingid = data.data_parsed.meeting_id;
            //       configService.branch_meetingid = meetingid;
            //     }

            //     /**
            //      * If badge id is there, put it in the fields
            //      */
            //     // console.log('hit branch data_parsed');
            //     // console.log('data_parsed', data['data_parsed']);

            //     if (data.data_parsed.badgeid != undefined) {
            //       let badgeid = data.data_parsed.badgeid;
            //       configService.branch_badgeid = badgeid;
            //     }
            //     if (data.data_parsed.email != undefined) {
            //       let email = data.data_parsed.email;
            //       configService.branch_email = email;
            //     }
            //   }

            //   resolve(true);

            //   // Logout to remove the sessions, else it makes linkedin sdk messed up
            //   branch.logout(function (err) {
            //     console.error('error:', err);
            //   });
            // });

            // if (branch == undefined) {
              resolve(true);
            // }
          },
          error => {
            resolve(false);
          }
        );
    }
  );
}
